import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Order } from '../shared/models/order';
import { Router } from '@angular/router';
import { DataService } from '../service/data.service';
import { UserService } from '../service/UserService';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent implements OnInit {
  hide = true;
  token: string | null = null;
  error = "";
  orders: Order[] = [];

  // Nuevas propiedades para la funcionalidad de 'olvidé mi contraseña'
  showForgotPassword = false;
  loading = false;
  message = '';
  email: string = ''; // Correo para el formulario de restablecimiento

  constructor(
    private router: Router,
    private data: DataService,
    private userService: UserService,
    private cdr: ChangeDetectorRef
  ) { }

  contactForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', Validators.required)
  });

  ngOnInit(): void {
    this.token = localStorage.getItem('token');

    if (this.token) {
      this.validationLogin(this.token);
    }
  }

  // Métodos de la funcionalidad de 'olvidé mi contraseña'
  toggleForgotPassword(): void {
    this.showForgotPassword = !this.showForgotPassword;
    this.message = ''; // Limpiar mensaje al cambiar de vista
    this.contactForm.reset();
    this.error = '';
  }

  resetPassword(): void {
    if (!this.email) {
      this.message = 'Por favor, ingrese su correo electrónico.';
      return;
    }

    this.loading = true;
    this.message = ''; // Limpiar mensaje anterior
    this.userService.resetPassword(this.email).subscribe(
      (response: any) => {
        this.loading = false;
        this.message = 'Enlace de restablecimiento enviado a su correo electrónico.';
        this.cdr.detectChanges();
      },
      (error) => {
        this.loading = false;
        console.error('Error al restablecer la contraseña:', error);
        this.message = 'Hubo un error. Revise su correo o intente de nuevo más tarde.';
        this.cdr.detectChanges();
      }
    );
  }

  translateDate(dateString: string | null | undefined): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('es-ES', { day: '2-digit', month: 'long', year: 'numeric' }).format(date);
  }

  fetchOrdersForCurrentUser(): void {
    const userStr = localStorage.getItem('cliente');
    if (userStr) {
      try {
        const cliente = JSON.parse(userStr);
        const userUid = cliente.uid;
        const userEmail = cliente.email;

        if (userUid && userEmail) {
          this.data.searchOrders(userUid, userEmail).subscribe(
            (data: Order[]) => {
              this.orders = data;
              this.cdr.detectChanges();
            },
            error => {
              console.error('Error al obtener pedidos:', error);
              if (error.status === 401 || error.status === 403) {
                this.clearAuthAndRedirect();
              }
            }
          );
        } else {
          this.clearAuthAndRedirect();
        }
      } catch (e) {
        this.clearAuthAndRedirect();
      }
    } else {
      this.clearAuthAndRedirect();
    }
  }

  validationLogin(token: string) {
    this.userService.validationLogin(token)
      .then(response => {
        localStorage.setItem('cliente', JSON.stringify(response.data));
        this.token = token;
        this.error = "";
        this.fetchOrdersForCurrentUser();
        this.cdr.detectChanges();
      })
      .catch(error => {
        this.error = "No estás logeado o tu sesión ha expirado.";
        this.clearAuthAndRedirect();
      });
  }

  private clearAuthAndRedirect(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('cliente');
    this.token = null;
    this.orders = [];
    this.router.navigate(['/']);
    this.cdr.detectChanges();
  }

  onLogin(): void {
    this.contactForm.markAllAsTouched();
    if (this.contactForm.invalid) {
      return;
    }

    const { email, password } = this.contactForm.value;
    const emailStr = email || '';
    const passwordStr = password || '';

    this.userService.login(emailStr, passwordStr)
      .then(response => {
        if (response && response.data && response.data.token) {
          const receivedToken = response.data.token;

          localStorage.setItem('token', receivedToken);
          localStorage.setItem('cliente', JSON.stringify(response.data));
          
          // **Recarga la página para forzar la actualización del estado**
          window.location.reload();

        } else {
          this.error = "Error al obtener el token de sesión.";
          this.cdr.detectChanges();
        }
      })
      .catch(error => {
        this.contactForm.reset();
        this.error = "Usuario o contraseña incorrecto";
        this.cdr.detectChanges();
      });
  }

  register(): void {
    this.contactForm.markAllAsTouched();
    if (this.contactForm.invalid) {
      return;
    }

    const { email, password } = this.contactForm.value;
    const emailStr = email || '';
    const passwordStr = password || '';

    this.userService.register(emailStr, passwordStr)
      .then(response => {
        if (response && response.data && response.data.token) {
          const receivedToken = response.data.token;

          localStorage.setItem('token', receivedToken);
          localStorage.setItem('cliente', JSON.stringify(response.data));
          
          // **Recarga la página para forzar la actualización del estado**
          window.location.reload();
          
        } else {
          this.error = "Error al obtener el token de sesión después del registro.";
          this.cdr.detectChanges();
        }
      })
      .catch(error => {
        this.contactForm.reset();
        this.error = "Ya se encuentra registrada esa cuenta.";
        this.cdr.detectChanges();
      });
  }

  viewOrderDetails(order: Order): void {
    if (order) {
      this.data.setOrder(order);
      this.router.navigate(['/order-details']);
    } else {
      console.error('La orden está indefinida');
    }
  }
}